module.exports = __webpack_public_path__ + "static/media/test.c6549735.mp3";